/**
 * Stories Domain Hooks
 */

// Audio recording (moved to media context)
export {
  useAudioRecorder,
  type UseAudioRecorderReturn,
  type UseAudioRecorderOptions,
} from '@/contexts/media/hooks/useAudioRecorder';

// React Query hooks
export { useStories } from './useStories';
export { useStory } from './useStory';
export { useVoicePresets, useCustomVoices } from './useVoices';
export { useStoryMutations } from './useStoryMutations';
export { useBlockMutations } from './useBlockMutations';
export { useGenerationMutations } from './useGenerationMutations';
export { useCustomVoicePreviewMutation } from './useVoicePreviewMutation';
export { useToggleStoryFavorite } from './useToggleStoryFavorite';

